<div class="user_details" #userDetails>
    <div class="flex-column">
        <div class="company_info">
            @if (companyLogo$ | async; as companyLogo) {
                <span class="company_logo"><img [src]="companyLogo" /></span>
            }
            <span class="company_name">{{ siloName$ | async }}</span>
            <div class="flex-column user-menu-button" [matMenuTriggerFor]="menu" data-testid="user-menu-button">
                <mat-icon class="size-auto">
                    <i class="fal fa-cog"></i>
                </mat-icon>
            </div>
        </div>
        @if (silos$ | async; as silos) {
            @if (silos.length > 1 && currentSilo$ | async; as currentSilo) {
                <mat-form-field appearance="outline" class="silo-select" [class.opened]="isSiloSelectOpened">
                    <mat-select
                        [formControl]="currentSiloControl"
                        panelClass="admin-silo-select dark-with-shadow"
                        (openedChange)="onSiloSelectOpenedChange($event)"
                    >
                        @if (silos.length >= 10) {
                            <div class="select-search">
                                <input
                                    [formControl]="siloFilterControl"
                                    placeholder="Search by Silo name"
                                    (click)="$event.stopPropagation()"
                                />
                            </div>
                        }

                        @for (silo of filteredSilos$ | async; track silo.id) {
                            <mat-option (click)="selectSilo(silo.id)" [value]="silo.id">
                                <span>
                                    {{ silo.name }}
                                    @if (currentSilo.id === silo.id) {
                                        <mat-icon class="silo-selected size-auto"
                                            ><i class="fal fa-check"></i
                                        ></mat-icon>
                                    }
                                </span>
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        }
        @if (userName) {
            <span class="name">{{ userName }}</span>
        }
    </div>
</div>

<mat-menu #menu="matMenu" yPosition="below" xPosition="after" class="user_menu">
    <div class="menu-wrapper">
        @if (hasAdminRights) {
            <div class="menu-header">
                {{ canAccessSuperadminSection ? 'Superadmin' : 'Administrator' }}
            </div>
            <div class="menu-item sm-display-none" mat-menu-item data-testid="providers-user-menu-button">
                <a routerLink="/app/admin/collections-providers" data-testid="providers-collections-menu-button">
                    Data collections
                </a>
            </div>
        }
        @if (canAccessSuperadminSection) {
            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/admin/settings" data-testid="silo-management-menu-button">Silo management</a>
            </div>
            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/admin/add-silo" data-testid="add-silo-menu-button">Add new silo</a>
            </div>
            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/admin/domains" data-testid="domains-management-menu-button">Domains management</a>
            </div>
        }
        @if (canAccessSuperadminSection || hasAdminRights) {
            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/admin/credits" data-testid="credits-menu-button">Manage Subscription</a>
            </div>

            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/admin/api" data-testid="api-menu-button">API Settings</a>
            </div>
            @if (organisationManagementEnabled$ | async) {
                <div class="menu-item sm-display-none" mat-menu-item>
                    <a routerLink="/app/admin/organisation-management" data-testid="organisation-management-menu-button"
                        >Organisation</a
                    >
                </div>
            }
            <div class="menu-item sm-display-none" mat-menu-item>
                <a routerLink="/app/users" id="usersNavLink" data-testid="manage-users-menu-button">Manage users</a>
            </div>
        }
        <div class="menu-item" data-testid="toggle-profile-user-menu-button" mat-menu-item (click)="toggleProfile()">
            Profile
        </div>

        <div class="menu-block-divider"></div>
        <div class="menu-item" data-testid="logout-user-menu-button" mat-menu-item (click)="signout()">Logout</div>
    </div>
</mat-menu>
